import { render } from "./CampLocationTable.vue?vue&type=template&id=2596fb2e&scoped=true"
import script from "./CampLocationTable.vue?vue&type=script&lang=js"
export * from "./CampLocationTable.vue?vue&type=script&lang=js"

import "./CampLocationTable.vue?vue&type=style&index=0&id=2596fb2e&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2596fb2e"]])

export default __exports__